export default theme => ({
  formControlLabel: {
    '& span': {
      fontSize: '1em',
    },
  },
})
